import "../design-system/styles.css";
import { LoadShowcase } from "../features/showcase/application/load-showcase";
import { StaticShowcaseRepository } from "../features/showcase/infrastructure/static-showcase-repository";
import { renderShowcase, type ShowcaseState } from "../features/showcase/presentation/render-showcase";
import { applyTheme, themeById } from "../design-system/themes";
import type { ComponentCategory } from "../features/showcase/domain/showcase-component";
import {
  showcasePlatformCapabilities,
  verifyShowcaseAdProviders,
} from "../features/showcase/infrastructure/platform-capabilities";

const root = document.querySelector<HTMLElement>("#app");
if (!root) throw new Error("No se encontró el contenedor principal");

const loadShowcase = new LoadShowcase(new StaticShowcaseRepository());
const components = loadShowcase.execute();
let state: ShowcaseState = {
  category: "push",
  view: "home",
  themeId: localStorage.getItem("ds-theme") ?? "showcase-base",
  analyticsCount: showcasePlatformCapabilities.count(),
};
void verifyShowcaseAdProviders();

function render(focusDetail = false): void {
  applyTheme(themeById(state.themeId));
  root!.innerHTML = renderShowcase("Design System Showcase", components, state);
  if (focusDetail) root!.querySelector<HTMLElement>("#detail-title, #components-title")?.focus();
}

root.addEventListener("click", (event) => {
  const target = (event.target as HTMLElement).closest<HTMLElement>("[data-action]");
  if (!target) return;
  const action = target.dataset.action;
  if (action === "navigate" && target.dataset.view) {
    state = { ...state, view: target.dataset.view as ShowcaseState["view"], componentId: undefined };
    render();
  }
  if (action === "choose-theme" && target.dataset.theme) {
    state = { ...state, themeId: target.dataset.theme };
    localStorage.setItem("ds-theme", target.dataset.theme);
    render();
  }
  if (action === "select-category" && target.dataset.category) {
    state = { ...state, category: target.dataset.category as ComponentCategory, componentId: undefined };
    render();
  }
  if (action === "open-component" && target.dataset.component) {
    state = {
      ...state,
      componentId: target.dataset.component,
      analyticsCount: showcasePlatformCapabilities.opened(state.category),
    };
    render(true);
  }
  if (action === "clear-analytics") {
    showcasePlatformCapabilities.clear();
    state = {...state, analyticsCount: 0};
    render();
  }
  if (action === "pages") {
    state = { ...state, view: "pages", componentId: undefined };
    render(true);
  }
  if (action === "back" || action === "home") {
    state = { ...state, view: action === "home" ? "home" : state.view, componentId: undefined };
    render(true);
  }
});

root.addEventListener("change", (event) => {
  const target = event.target as HTMLSelectElement;
  if (target.dataset.action !== "select-theme") return;
  state = { ...state, themeId: target.value };
  localStorage.setItem("ds-theme", target.value);
  render();
});

root.addEventListener("input", (event) => {
  const target = event.target as HTMLInputElement;
  if (target.dataset.action !== "search-components") return;
  state = { ...state, query: target.value };
  render();
  const search = root!.querySelector<HTMLInputElement>("#component-search");
  search?.focus();
  search?.setSelectionRange(target.value.length, target.value.length);
});

render();
